import React from 'react';
import { cn } from '../../lib/cn';
import { Button } from './Button';

interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: {
    label: string;
    onClick: () => void;
    icon?: React.ReactNode;
  };
  className?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  description,
  action,
  className,
}) => {
  return (
    <div className={cn('flex flex-col items-center text-center px-5 py-14', className)}>
      {icon && (
        <div className="mb-4 text-gray-400 dark:text-zinc-500 [&>svg]:h-10 [&>svg]:w-10">{icon}</div>
      )}
      <h3 className="text-base font-medium text-gray-900 dark:text-zinc-100">{title}</h3>
      {description && (
        <p className="mt-1.5 text-sm text-gray-500 dark:text-zinc-400 max-w-md">{description}</p>
      )}
      {action && (
        <div className="mt-5">
          <Button variant="primary" onClick={action.onClick} icon={action.icon}>
            {action.label}
          </Button>
        </div>
      )}
    </div>
  );
};

export default EmptyState;
